import { Contact } from "@/components/contact";
import { LocaleSelect } from "@/components/locale-select";
import { useGetPublicJobopening } from "@/queries/jobopenings/queries";
import styled from "@emotion/styled";
import { DSTestLandingPage } from "@hundred5/design-system";
import { Trans } from "@lingui/react/macro";
import { useRouter } from "next/router";

export function PausedPage() {
  const router = useRouter();
  const jobOpeningSlug = router.query.slug as string;
  const { data: jobOpening } = useGetPublicJobopening(jobOpeningSlug as string);

  if (!jobOpening) {
    return null;
  }

  return (
    <Page>
      <DSTestLandingPage>
        <DSTestLandingPage.TitleImage
          url={jobOpening.backgroundUrl}
          position={jobOpening.backgroundPosition}
        />

        <DSTestLandingPage.Header>
          <DSTestLandingPage.Logo url={jobOpening.logoUrl} />
          <Locale>
            <LocaleSelect />
          </Locale>
        </DSTestLandingPage.Header>

        <DSTestLandingPage.Main>
          <Title>
            <Trans>
              {jobOpening.name} at {jobOpening.companyName}
            </Trans>
          </Title>
          <Content>
            <Trans>
              This job is paused and is no longer accepting applications.
            </Trans>
            <br />
          </Content>
        </DSTestLandingPage.Main>

        <DSTestLandingPage.Footer>
          <Contact
            companyName={jobOpening.companyName}
            contactEmail={jobOpening.contactEmail}
          />
        </DSTestLandingPage.Footer>
      </DSTestLandingPage>
    </Page>
  );
}

const Page = styled.div<{ embedded?: boolean }>`
  display: grid;
  grid-template-rows: max-content auto;
  min-height: ${(props) => (props.embedded ? "100%" : "100vh")};
  background-color: ${(props) => props.theme.colors.white};
  padding-bottom: 32px;

  @media (min-width: 768px) {
    background-color: transparent;
    padding: clamp(32px, 4%, 56px) 32px 32px 32px;
    row-gap: 8px;
  }
`;

const Locale = styled.div`
  margin-left: auto;
  margin-top: 16px;

  @media (min-width: 768px) {
    margin-top: 24px;
  }
`;

const Title = styled.div`
  color: ${(props) => props.theme.colors.purple[100]};
  font-size: 22px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
`;

const Content = styled.p`
  font-size: 14px;
  line-height: 32px;
  margin: 24px 0;
`;

const Link = styled.a`
  color: ${(props) => props.theme.colors.purple[100]};
  text-decoration: underline;
`;
